module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "GlobalErrors"
  }, [_vm._l((_vm.errors), function(error, index) {
    return [_c('transition', {
      attrs: {
        "name": "error-toast"
      }
    }, [_c('div', {
      staticClass: "GlobalErrors__toast"
    }, [_c('div', {
      staticClass: "GlobalErrors__close",
      on: {
        "click": function($event) {
          _vm.removeError(index)
        }
      }
    }), _vm._v("\n                " + _vm._s(error) + "\n            ")])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398a8091"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/GlobalErrors.vue
// module id = 656
// module chunks = 1